import React from 'react';
import { Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { DATA_HOOKS } from '../../../../dataHooks';
import { getQuarter } from '../../../../utils/text';
export var ETATag = function (_a) {
    var eta = _a.eta;
    var t = useTranslation().t;
    if (!eta) {
        return null;
    }
    var _b = getQuarter(eta), quarter = _b.quarter, year = _b.year;
    return (React.createElement(Text, { dataHook: DATA_HOOKS.SEARCH_RESULT_TAG_ETA, textAlign: "center", size: 'tiny', weight: "thin", className: 'etaText' },
        "\u00B7 ",
        t('shared.roadmap.article-item.eta', { quarter: quarter, year: year }),
        " \u00B7"));
};
//# sourceMappingURL=index.js.map